/**
 * 三列内 setting `key` 的展示顺序（与 Figma 内容区 `1834:50121` 自上而下一致）。
 * 与自助点餐通用设置页、首屏骨架共用，保证行数与真实 DOM 一一对应。
 */
export const SELF_ORDER_COL1_KEYS: readonly number[] = [3, 38, 2, 73, -2, 9, -3, 167, 118, 29, 111, -111, -111.1];
export const SELF_ORDER_COL2_KEYS: readonly number[] = [78, 103, 21, 22, 108, 95, 136, 105, 156, 1];
/** 稿中无「结账后 COP 返回」项，保留在列末以便配置仍存在 */
export const SELF_ORDER_COL3_KEYS: readonly number[] = [27, 42, 107, 39, 93, 109, 133, 129, 138, 143, 139, 140, 86, 158, 180];
